import { CookiesName, getCookie } from '@/utils/cookies'
import { defineStore } from 'pinia'

enum AuthState {
  Unknown,
  Authenticated,
  Unauthenticated
}

interface State {
  authenticated: AuthState
  token: string | null
}

export const useAuthStore = defineStore({
  id: 'auth',
  state: (): State => ({ authenticated: AuthState.Unknown, token: null }),
  getters: {
    isAuthenticated(): boolean {
      return this.authenticated === AuthState.Authenticated
    },
    isUnknown(): boolean {
      return this.authenticated === AuthState.Unknown
    },
    authToken(): string | null {
      return this.token
    }
  },
  actions: {
    setAuthenticated(authenticated: boolean) {
      this.authenticated = authenticated ? AuthState.Authenticated : AuthState.Unauthenticated
    },
    setAuthToken(token: string | null) {
      this.token = token
      if (token) {
        localStorage.setItem('authToken', token)
      } else if (getCookie(CookiesName.Token)) {
        localStorage.setItem('authToken', getCookie(CookiesName.Token) as string)
      }
      this.authenticated = token !== null ? AuthState.Authenticated : AuthState.Unauthenticated
    },
    disconnect() {
      this.token = null
      this.authenticated = AuthState.Unauthenticated
    }
  }
})
